import moment, { Moment } from 'moment';
import { Control, Controller, FieldValues, Path } from 'react-hook-form';
import { ISize } from '../interface';
import { StyledDatePicker } from './FormDatePicker.styles';
import { CSSProperties } from 'react';

interface Props<F extends FieldValues> {
    name: Path<F>;
    control: Control<F>;
    label?: string;
    required?: boolean;
    disabled?: boolean;
    readOnly?: boolean;
    size?: ISize;
    placeholder?: string;
    sx?: CSSProperties;
}

const FormDatePicker = <F extends FieldValues>(props: Props<F>) => {
    const {
        name,
        control,
        label,
        required,
        disabled,
        size = 'small',
        placeholder,
        sx,
    } = props;

    return (
        <Controller
            name={name}
            control={control}
            render={({ field: { onChange, value }, fieldState: { error } }) => {
                const momentValue =
                    typeof value === 'string' && value
                        ? moment(value)
                        : (value as Moment || null);

                return (
                    <StyledDatePicker
                        label={label && (required ? `${label} *` : label)}
                        value={momentValue}
                        onChange={(date: Moment | null) => {
                            onChange(date?.format('YYYY-MM-DDTHH:mm:ss.SSS'));
                        }}
                        slotProps={{
                            textField: {
                                variant: 'outlined',
                                size: size,
                                error: Boolean(error),
                                helperText: error && error.message,
                                placeholder: placeholder,
                                sx: {
                                    '& .MuiInputBase-root': {
                                        borderRadius: '15px',
                                    },
                                },
                            },
                        }}
                        format="DD/MM/YYYY"
                        disabled={disabled}
                        sx={sx}
                    />
                );
            }}
        />
    );
};

export default FormDatePicker;
